import type { PartnerBlocklistApi } from './partner-blocklist-api.types';

import http from './partner-blocklist-api.http';

export default {
  getByDocument: async (document: string) => {
    const res = await http.get<PartnerBlocklistApi.BlocklistRecord[]>('', {
      params: {
        cnpj: document,
      },
    });

    return res.data;
  },
};
